import { showSuccess, showError, showWarning } from "../../../components/ModernSnackbar";
import { deleteUser, generateLink } from "../../../services/api/fytnServices";

export const handleGenerateLink = async (ids, setModalOpen, setTestLink,master_id,) => {
  setModalOpen(true);

  const idArray = Array.isArray(ids) ? ids : [ids];
  let allLinks = [];
  let success = false;

  try {
    for (const id of idArray) {
      const res = await generateLink(id,master_id);

      if (res?.data?.testLink !== null) {
        allLinks.push({ id, link: res.data.testLink });
        success = true; // Set success flag if at least one link is generated
      } 
    }

    if (allLinks.length > 0) {
      setTestLink(allLinks[0].link); // Or handle allLinks if needed

      if (success) {
        showSuccess("Links generated successfully");
      } else {
                  showWarning("No links were available");
      }
    } else {
              showWarning("No links available for the selected IDs");
    }

  } catch (error) {
          showError("Error generating link(s)");
    console.error(error);
  }
};


export const handleDelte=async(adminId,userId,setRefetch,setOpenConfirmationDialog)=>{
   const UserIdsArray = Array.isArray(userId) ? userId : [userId];
 
  console.log("Delete Debug - adminId:", adminId);
  console.log("Delete Debug - userIds:", UserIdsArray);
 
  try{
    const res=await deleteUser(adminId,UserIdsArray)
    
    if(res.status===200){
      const responseData = res.data;
      console.log("Delete response:", responseData);
      
      // Check if the operation was successful based on the result structure
      if(responseData.result && responseData.result.success === true){
        setRefetch(true);
        
        // Enhanced success message based on what was deleted
        const deletedFromMapping = responseData.result.deletedIds?.length || 0;
        const deletedFromMaster = responseData.result.deletedFromMaster?.length || 0;
        
        if (deletedFromMaster > 0) {
          showSuccess(`${deletedFromMapping} user(s) removed from your list and ${deletedFromMaster} user(s) completely deleted from system`);
        } else {
          showSuccess(`${deletedFromMapping} user(s) removed from your list`);
        }
        
        setOpenConfirmationDialog(false);
      } else if(responseData.result && responseData.result.success === false){
        // Handle the case where no users were found to delete
        if(responseData.result.message === "No users found to delete"){
          showError("Cannot delete users who have already submitted tests");
        } else {
          showError(responseData.result.message || "Error deleting users");
        }
        setOpenConfirmationDialog(false);
      } else if(responseData.status === 'success'){
        // Fallback for other response structures
        setRefetch(true);
        showSuccess("User set to inactive successfully");
        setOpenConfirmationDialog(false);
      } else if(responseData.status === 'error'){
        // Handle specific error cases
        if(responseData.data?.reason === 'tests_submitted'){
          showError("Cannot deactivate users who have already submitted tests");
        } else if(responseData.data?.reason === 'users_not_found'){
          showError("No users found in the system");
        } else {
          showError(responseData.message || "Error deactivating users");
        }
        setOpenConfirmationDialog(false);
      } else {
        // Default error handling
        showError("Error deleting users");
        setOpenConfirmationDialog(false);
      }
    } else {
      showError("Error deleting users");
      setOpenConfirmationDialog(false);
    }

  }catch(error){
    showError("Error deleting user");
    console.error(error);
    setOpenConfirmationDialog(false);
  }
}